var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg85(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 6.22852C14.6665 6.54493 14.4314 6.80642 14.1263 6.84781L14.0415 6.85352L1.5415 6.85352C1.19633 6.85352 0.916505 6.57369 0.916505 6.22852C0.916505 5.9121 1.15163 5.65061 1.4567 5.60922L1.5415 5.60352L14.0415 5.60352C14.3867 5.60352 14.6665 5.88334 14.6665 6.22852Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.024 10.8059C7.2686 11.0495 7.26945 11.4452 7.0259 11.6898C6.80449 11.9122 6.45731 11.9331 6.21225 11.7521L6.14202 11.6917L1.10035 6.67173C0.877322 6.44966 0.857033 6.10123 1.03949 5.85617L1.10032 5.78599L6.14198 0.765152C6.38656 0.52158 6.78229 0.5224 7.02586 0.766982C7.24729 0.98933 7.26675 1.33659 7.08469 1.58089L7.02403 1.65086L2.42734 6.22909L7.024 10.8059Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg85);
export default __webpack_public_path__ + "static/media/svg85.a3fa00688504182041ded6f2167ec3f4.svg";
export { ForwardRef as ReactComponent };